import React from 'react'
import PropTypes from 'prop-types'

import Analytics from './HOC/Analytics'
import Title from './HOC/Title'
import SignInError from '../components/SignInError'

function SignInErrorContainer({ data }) {
  return <SignInError data={data} />
}

SignInErrorContainer.propTypes = {
  data: PropTypes.object,
}

export default Title(Analytics(SignInErrorContainer), 'Acesso – Hi Platform')



// WEBPACK FOOTER //
// ./src/containers/SignInError.js